module.exports = __webpack_public_path__ + "img/bf.1737a524.svg";